import {TriggerExpression} from '@models/adminstration/machine/trigger/trigger-expression';
import {TimeDependencyConfig} from '@models/adminstration/machine/trigger/time-dependency-config';
import {SignalEdge} from '@models/adminstration/machine/trigger/signal-edge';
import {TRIGGER_TYPE} from '@constants/administration/machine/trigger-type';

export class AddTriggerConfigurationRequest {
  cloudplugId: string | null;
  effectiveStartDate: string;
  id: number;
  name: string;
  signalEdge: SignalEdge;
  timeDependencyConfig: TimeDependencyConfig;
  timestamp: number;
  triggerExpressions: TriggerExpression[];
  triggerQueries: any[];
  triggerType: TRIGGER_TYPE;

  constructor(addTriggerConfigurationRequest?: AddTriggerConfigurationRequest) {
    this.cloudplugId = addTriggerConfigurationRequest?.cloudplugId || null;
    this.effectiveStartDate = addTriggerConfigurationRequest?.effectiveStartDate || '';
    this.id = addTriggerConfigurationRequest?.id || -1;
    this.name = addTriggerConfigurationRequest?.name || '';
    this.signalEdge = addTriggerConfigurationRequest?.signalEdge || SignalEdge.FALLING_EDGE;
    this.timeDependencyConfig = addTriggerConfigurationRequest?.timeDependencyConfig || new TimeDependencyConfig();
    this.timestamp = addTriggerConfigurationRequest?.timestamp || 0;
    this.triggerExpressions = addTriggerConfigurationRequest?.triggerExpressions || new Array<TriggerExpression>();
    this.triggerQueries = addTriggerConfigurationRequest?.triggerQueries || new Array<any>();
    this.triggerType = addTriggerConfigurationRequest?.triggerType || TRIGGER_TYPE.UNKNOWN;
  }
}

export class TriggerConfiguration extends AddTriggerConfigurationRequest{
  cloudplug?: string | null;
  isActive: boolean;
  isJustActivated: boolean;
  lastExecution: string | null;
  lastExpressionResolveResult: boolean;
  lastExpressionResult: boolean;
  parent: string;
  resolveActions: number[];
  triggerActionsExecuted: boolean;
  triggerInterval: number;
  triggerIntervalType: string | null;
  triggerQueryIds: number[];
  triggerResolveActionsExecuted: boolean;

  constructor(triggerConfiguration?: TriggerConfiguration) {
    super(triggerConfiguration);
    this.isActive = triggerConfiguration?.isActive || false;
    this.isJustActivated = triggerConfiguration?.isJustActivated || false;
    this.lastExecution = triggerConfiguration?.lastExecution || null;
    this.lastExpressionResolveResult = triggerConfiguration?.lastExpressionResolveResult || false;
    this.lastExpressionResult = triggerConfiguration?.lastExpressionResult || false;
    this.parent = triggerConfiguration?.parent || '';
    this.resolveActions = triggerConfiguration?.resolveActions || [];
    this.triggerActionsExecuted = triggerConfiguration?.triggerActionsExecuted || false;
    this.triggerInterval = triggerConfiguration?.triggerInterval || 0;
    this.triggerIntervalType = triggerConfiguration?.triggerIntervalType || null;
    this.triggerQueryIds = triggerConfiguration?.triggerQueryIds || [];
    this.triggerResolveActionsExecuted = triggerConfiguration?.triggerResolveActionsExecuted || false;
  }
}
